import { render, staticRenderFns } from "./list.vue?vue&type=template&id=1bb8f05c&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=1bb8f05c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb8f05c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bb8f05c')) {
      api.createRecord('1bb8f05c', component.options)
    } else {
      api.reload('1bb8f05c', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=1bb8f05c&scoped=true", function () {
      api.rerender('1bb8f05c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dental/order/list.vue"
export default component.exports